<template>
    <div class="modal_card">
        <div class="header">
            <h4 class="title">
                {{ translate('company_services.add_tariff') }}
            </h4>
        </div>
        <div class="content">

            <div class="row">
                <div class="col-md-12">
                    <label> {{ translate('company_services.ts_end') }} </label>
                    <fg-input class="mx-input"
                      type='datepicker'
                      v-model="new_tariff.ts_end"
                      :range="false"
                      format="DD-MM-YYYY"
                      :placeholder="translate('company_services.ts_end')"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <label> {{ translate('company_services.client_name') }} </label>
                    <sis-select
                        :options="client_list"
                        :multiple="false"
                        v-model="new_tariff.client_id"
                        :placeholder="translate('company_services.client_name')"
                        :clearable="false"
                        :max_height="120"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-12" >
                    <fg-input
                        v-model="new_tariff.name"
                        type="text"
                        :label="translate('company_services.tariff_name')"
                        :placeholder="translate('company_services.tariff_name')"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-12" >
                    <fg-input
                        v-model="new_tariff.cost"
                        type="number"
                        :label="translate('company_services.tariff_cost')"
                        :placeholder="translate('company_services.tariff_cost')"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ translate('company_services.tariff_descr') }}</label>
                        <textarea
                            v-model="new_tariff.descr"
                            rows="5"
                            class="form-control border-input"
                            :placeholder="translate('company_services.tariff_descr')"
                        />
                    </div>
                </div>
            </div>

            <div class="text-center">
                <button
                    class="btn btn-info btn-fill btn-wd"
                    @click.prevent="add_tariff()"
                >
                    {{ translate("support.add") }}
                </button>
                <button
                    type="submit"
                    class="btn btn-danger btn-fill btn-wd"
                    @click.prevent="cancel"
                >
                    Cancel
                </button>
            </div>
            <div class="clearfix" />
        </div>
    </div>
</template>
<script>

export default {
    name: "AddDeviceTariff",
    props: ['clients'],
    data () {
        return {
            new_tariff:{
                client_id: null,
                name: '',
                cost: '',
                descr: "",
                ts_end: null
            }
        }
    },

    computed:{
        client_list(){
            let list = [{id: '', label: 'Not selected', isDisabled: true }]
            for (let client of this.clients) {
                list.push({ id: client.id, label: client.name })
            }
            return list
        },
    },

    created() {
    },

    methods: {
        cancel () {
            this.$emit('close')
        },
        add_tariff(){
            this.$emit('confirm', {...this.new_tariff})
        }

    }
}
</script>
<style lang="scss" scoped>
.modal_card{
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header{
    .title{
      margin-top: 15px;
    }
  }
}

</style>
